import React, { useState, useEffect } from 'react';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import { useHistory, useLocation } from 'react-router-dom';
import { useStyles } from './styles';
import Cookies from 'universal-cookie';
import "./styles.scss"
import Logo from "./logo-fpt.png"
import Background from "./login.svg"
import { Form, FormGroup } from 'reactstrap';
import { useKeycloak } from "@react-keycloak/web";
import { TwinSpin } from 'react-cssfx-loading/lib';

const cookies = new Cookies();
//sessionStorage
let StorageUser = sessionStorage.getItem('User');
let StorageName = sessionStorage.getItem('Name');
cookies.remove('errorDescription');
cookies.remove('errorDescription', { path: '/' });
// eslint-disable-next-line 
let  detailerr

function UserFormInput(initialCount) {
    const [value, setValue] = useState(initialCount);
    function handleChange(e) {
        setValue(e.target.value);
    }
    return {
        value: value,
        onChange: handleChange
    };
}
const clearstorage = () => {
    sessionStorage.clear();
    localStorage.clear();
    window.location.reload();
};


const HandleEffectLogin = () => {
    return (
        <>
        </>
    )
}
function SignIn(props) {


    const username = UserFormInput("");
    const classes = useStyles();
    // eslint-disable-next-line
    const [inputType, setInputType] = useState("password");
    // eslint-disable-next-line
    const [eyeOnOff, setEyeOnOff] = useState(false);
    const [effect, setEffect] = useState(true)
    // eslint-disable-next-line
    const { keycloak, initialized } = useKeycloak();
    const [status1, setStatus1] = useState();
    // eslint-disable-next-line
    const usernamelogin = username.value.trim();

    if (StorageUser != null) {
        // eslint-disable-next-line
        usernamelogin = StorageUser;
    }
    // function onLogin(e) {
    //     e.preventDefault();
    //     //window.location = 'https://iam.fpt.net/auth/realms/fpt/protocol/openid-connect/auth?client_id=itsm&redirect_uri=http://localhost:3000/PlanTemplate/Main&state=dd9c5a81-3312-48f9-8783-488b4e0b6491&response_mode=fragment&response_type=code&scope=openid&nonce=297a7df2-8655-4cb0-b86c-4ff98d02848f&code_challenge=RmNmTm5u2A1QbFz5dFG-Jolw7XeNx1w5McH47H5UFe8&code_challenge_method=S256';
    //     props.Login(usernamelogin, password.value.trim());
    // }

    let history = useHistory();
    let location = useLocation();

    useEffect(() => {
        if(localStorage.getItem('keycloakcode'))
        {
            var token = localStorage.getItem('keycloakcode');
            if (token) {
                props.Login(token);
            }
        }
        // if (window.location.href.includes('code')) {
        //     const code = window.location.href.split('=');
        //     localStorage.setItem('keycloakcode', code[3]);
        //     setStatus(1);

        // }
        // eslint-disable-next-line
    },[status1]);

    useEffect(() => {
        if (window.location.href.includes('code')) {
            const code = window.location.href.split('code');
            localStorage.setItem('keycloakcode', code[code.length -1].replace('=','').trim());
            setStatus1(!status1);
        }
        if (!localStorage.getItem('ShowEffect')) {
            setTimeout(() => setEffect(false), 4500)
            localStorage.setItem('ShowEffect', true, 1)
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (props.ResultLogin) {
            var isAuthenticated = cookies.get('usercode');
            let { from } = location.state || { from: { pathname: "/Dashboard" } };
            if (isAuthenticated) {
                history.replace(from);
            }
        }
        // eslint-disable-next-line
    }, [props.ResultLogin]);

    let errorDescription = cookies.get('errorDescription');
    let KQerrr = false;
    if (errorDescription === "Account is not fully set up") {

        detailerr = 'Tài khoản cần phải cập nhật mật khẩu mới vui lòng truy cập link để cập nhật!';
        KQerrr = true;
    }
    const styles = {
        paperContainer: {
            backgroundColor: '#01a096',
            // background: 'linear-gradient(0deg, rgb(9, 163, 154) 0%, rgb(62, 202, 200) 90%, rgb(64, 204, 200) 100%)',
            objectFit: 'cover',
            backgroundRepeat: 'no-repeat',
            /* width: 181%; */
            /* background-position: bottom; */
            backgroundSize: 'cover',
            zIndex: 0,
            width: '30%',
        },
        imageContainer: {
            backgroundImage: `url(${Background})`,
            objectFit: 'cover',
            backgroundRepeat: 'no-repeat',
            width: '70% ',
            position: 'relative',
        }
    };
    // const HandleShowPassword = () => {
    //     if (inputType === "text") {
    //         setInputType("password")
    //         setEyeOnOff(false)
    //     } else if (inputType === "password") {
    //         setInputType("text")
    //         setEyeOnOff(true)
    //     }
    // }
    const HanldeLogin = () => {
        keycloak.login();
    }
    // const HandleTimeOutEffect = setTimeout(() => HandleEffectLogin, 3000)
    // useEffect(() => {
    //     console.log("Thanh1");
    //     if (!localStorage.getItem('ShowEffect')) {
    //         setTimeout(() => setEffect(false), 4500)
    //         localStorage.setItem('ShowEffect', true, 1)
    //     }
    // }, [])
    // if (!cookies.get('usercode') && status === 0) {
    //     return <div style={{ position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }} >
    //         <TwinSpin color="var(--itsm-bg-btn)" width="50px" height="50px" duration="0.5s" />
    //     </div>
    // }
    // else {
    return (
        <div style={{ display: 'flex', position: 'relative' }}>
            <Paper style={styles.imageContainer} className="paper-login">

                {/* <div style={{position: 'absolute', background: "rgba(25, 213, 200, .9)", bottom: '0px', right: '30px', width: '30%', height: '90%', display: 'flex', alignItems: 'center'}} className="welcome-container">
                        <div className={classes.LogoLoginPage}>
                            <Grid container spacing={4} alignItems="center" columns={5} style={{paddingLeft: '20px', paddingTop: '100px'}}>
                                <Typography component="h2" variant="h3" className={classes.LogoIT}>
                                    WELCOME
                                </Typography>
                            </Grid>
                            <Grid container spacing={4} alignItems="center" columns={5} style={{paddingLeft: '20px', paddingTop: '16px'}}>
                                <Typography component="h2" variant="h3" className={classes.LogoIT} style={{paddingTop: '16px'}}>
                                    TO
                                </Typography>
                            </Grid>
                            <Grid container spacing={4} alignItems="center" columns={5}>
                                <Grid item xs={2}>
                                    <Typography component="h1" variant="h1" className={classes.LogoIT}>
                                        IT
                                    </Typography>
                                </Grid>
                                <Grid item xs={2} className={classes.LogoSM}>
                                    <Typography component="h1" variant="h5" className={`logo-sm`}>
                                        Service Management
                                    </Typography>
                                </Grid>
                            </Grid>
                        </div>
                    </div> */}
                <Grid item xs={2.5}>
                    <Box
                        component="img"
                        sx={{
                            height: 64,
                        }}
                        alt="Your logo."
                        src={Logo}
                        className={classes.LogoFPT}
                    />
                </Grid>
            </Paper>
            {localStorage.getItem('ShowEffect') && (<Paper style={styles.paperContainer} className='login-contanier' loading="lazy">

                <div className={classes.LoginPageContainer} >
                    <Container component="main" maxWidth="xs">
                        <CssBaseline />
                        <div className={classes.paper}>
                            <Typography component="h1" variant="h5" className={classes.TieuDe}>
                                Hello{StorageName != null ? ", " + StorageName : "!"}
                            </Typography>
                            <Form className={classes.form} noValidate>
                                {/* onSubmit={onLogin}> */}
                                {/* <FormGroup style={{ display: StorageName != null ? "none" : "block" }}>
                                    <Label className={classes.FormLabel}><HiOutlineMail /></Label>
                                    <Input
                                        variant="standard"
                                        margin="normal"
                                        required
                                        fullWidth
                                        id="email"
                                        // label="Email"
                                        name="email"
                                        placeholder="IAM Account"
                                        autoComplete="email"
                                        autoFocus
                                        {...username}
                                        // InputProps={{
                                        //     startAdornment: (
                                        //         <InputAdornment position="start">
                                        //             <MailOutlineIcon />
                                        //         </InputAdornment>
                                        //     )
                                        // }}
                                        className={classes.LoginField}
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <Label className={classes.FormLabel}><FiUnlock /></Label>
                                    <Input
                                        variant="standard"
                                        margin="normal"
                                        required
                                        fullWidth
                                        name="password"
                                        label="Password"
                                        type={inputType}
                                        id="password"
                                        placeholder="IAM password"
                                        autoComplete="current-password"
                                        {...password}
                                        // InputProps={{
                                        //     startAdornment: (
                                        //         <InputAdornment position="start">
                                        //             <VpnKeyIcon />
                                        //         </InputAdornment>
                                        //     )
                                        // }}
                                        className={classes.LoginField}
                                    />
                                <Label className={classes.FormLabelRight}>
                                    {
                                        eyeOnOff ? <FiEye onClick={HandleShowPassword} /> 
                                        : <FiEyeOff onClick={HandleShowPassword} />
                                    } 
                                </Label>
    
                                </FormGroup> */}
                                <FormGroup>

                                    {/* <Button
                                        type="submit"
                                        fullWidth
                                        variant="contained"
                                        color="primary"
                                        className={classes.submit} >
                                        SIGN IN
                                    </Button> */}
                                    {
                                        localStorage.getItem('keycloakcode') && <div style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }} >
                                            <TwinSpin color="white" width="50px" height="50px" duration="0.5s" />
                                        </div>
                                    }
                                    <Button fullWidth
                                        variant="contained"
                                        color="primary"
                                        className={classes.submit} onClick={HanldeLogin} hidden={localStorage.getItem('keycloakcode') ? true : false}>Login IAM</Button>
                                </FormGroup>
                                <Grid container>
                                    <Grid item xs>
                                        <Link href="#" onClick={clearstorage} variant="body2" className={classes.noremember}>
                                            {StorageName != null ? "Không phải tôi" : ""}
                                        </Link>
                                    </Grid>
                                    <Grid item>
                                        <Link href="https://iam.fpt.vn/auth/realms/fpt/login-actions/reset-credentials?client_id=account-console&tab_id=PGehhwOtgVE" variant="body2" className={classes.noremember}>
                                            Forgot Password?
                                        </Link>
                                    </Grid>
                                </Grid>
                                <div><Link href="https://iam.fpt.vn/auth/realms/fpt/protocol/openid-connect/auth?client_id=account-console&redirect_uri=https%3A%2F%2Fiam.fpt.vn%2Fauth%2Frealms%2Ffpt%2Faccount%2F%23%2F&state=f3d6e0e5-f4cb-4a63-9193-e2956f089400&response_mode=fragment&response_type=code&scope=openid&nonce=b75260c4-49b5-495c-8319-bb175a03c4a4&code_challenge=IHFn6TdsVSlwAWJP443PdpBQPOK8pj-Zzjn_2yda_84&code_challenge_method=S256" target="_blank" className={classes.noremember} style={{ marginLeft: "43%", display: KQerrr === false ? "none" : "block" }}  >Change Password</Link></div>
                            </Form>
                        </div>
                    </Container>
                </div>
            </Paper>)}
            {!localStorage.getItem('ShowEffect') && StorageName === null && effect && (<HandleEffectLogin />)}
        </div>
    );
}
export default SignIn;
